import { z } from 'zod';

export const consumerFormSchema = z.object({
  username: z
    .string()
    .min(1, '사용자명을 입력하세요')
    .max(128, '최대 128자'),
  customId: z.string().max(128, '최대 128자').optional(),
  tags: z.record(z.unknown()).optional(),
  enabled: z.boolean().default(true),
});

export type ConsumerFormValues = z.infer<typeof consumerFormSchema>;
